import format from "date-fns/fp/format";

export const formatEndTime = (d: Date) => {
  return format("hh:mm a (E, yyyy-MM-dd)")(d);
};
